import { create } from '@/store'
import { devtools } from 'zustand/middleware'

export const useCustomerAttributeListStore = create(
  devtools(
    (set) => ({
      page: 1,
      pageSize: 10,
      setPage: (page) => set({ page }),
      setPageSize: (pageSize) => set({ pageSize }),
    }),
    {
      name: 'customer-attribute-list-store',
    },
  ),
)
